var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7676 5.53591L6.53375 13.7698C5.48844 14.8151 4.96579 15.3377 4.32889 15.6936C3.69199 16.0495 2.18809 16.4076 0.75 16.75C1.0924 15.3119 1.45047 13.808 1.80637 13.1711C2.16226 12.5342 2.68493 12.0116 3.73023 10.9663L11.9641 2.73239L13.3658 1.33063C14.14 0.556457 15.3952 0.556457 16.1694 1.33063C16.9435 2.1048 16.9435 3.35998 16.1694 4.13415L14.7676 5.53591ZM11.9641 2.73239L14.7676 5.53591",
    stroke: "#7B8794",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 16.75H13.75",
    stroke: "#7B8794",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLine2);
export default __webpack_public_path__ + "static/media/edit-line-2.11babb34ecdf3f87c9d168f9643a48e6.svg";
export { ForwardRef as ReactComponent };